
import { SAVE_SCANNED_WORK_CENTER_CODE } from '@/store/actions'
import { PROJECT_CODE, QRCODE_BARCODE_TYPE_REGEX, QRCODE_BARCODE_TYPE_REGEX_NEW } from '@/utils/constants'
import { Vue } from 'vue-class-component'

export interface BarcodeParseResult {
  barcodeId: string
  projectId?: string
  isNewFormat: boolean
  isOldFormat: boolean
  detectedText: string
}

export default class BarcodeHandlerMixin extends Vue {
  parseBarcodeText(text: string): BarcodeParseResult {
    const valCode = text.trim()
    const urlParts = valCode.split('/')
    const detectedText = valCode || ''

    const isNewFormat = !!valCode.match(QRCODE_BARCODE_TYPE_REGEX_NEW)
    const isOldFormat = !!valCode.match(QRCODE_BARCODE_TYPE_REGEX)

    let barcodeId = ''
    let projectId: string | undefined

    if (isNewFormat) {
      barcodeId = urlParts.pop() || ''
    } else if (isOldFormat) {
      barcodeId = urlParts.pop() || ''
      urlParts.pop()
      projectId = urlParts.pop()
    }

    return {
      barcodeId,
      projectId,
      isNewFormat,
      isOldFormat,
      detectedText,
    }
  }

  processScannedText(text: string) {
    const result = this.parseBarcodeText(text)
    this.handleBarcodeResult(result)
  }

  handleBarcodeResult(result: BarcodeParseResult) {
    if (result.isNewFormat || result.isOldFormat) {
      this.$store.dispatch(SAVE_SCANNED_WORK_CENTER_CODE, '')
    }
    if (result.isNewFormat) {
      this.$router.push({
        name: 'detail',
        params: { barcodeId: result.barcodeId },
      })
    } else if (result.isOldFormat) {
      this.$router.push({
        name: 'detail',
        params: { barcodeId: result.barcodeId, project: result.projectId },
      })
    } else {
      this.$router.push({
        name: 'detail',
        params: { barcodeId: `projectCode=${PROJECT_CODE}` },
        query: { externalId: result.detectedText, isGenerateBarcode: 1 },
      })
    }
  }
}
